import isEmpty from "lodash/isEmpty";
import * as React from "react";
import { useTranslation } from "react-i18next";

import ModalMediaGallery from "../ModalMediaGallery";

import Button from "~/components/atoms/Button";
import CleanedContent from "~/components/atoms/CleanedContent";
import Typo from "~/components/atoms/Typo";
import { TMedia } from "~/entities/media";
import { cn } from "~/utilities/cn";
import { ETypoColor } from "~/utilities/enums/Colors";
import { ETypoTag, ETypoVariant } from "~/utilities/enums/Typo";

export interface ProjectSitePlanProps {
  sitePlanImages: TMedia;
  sitePlanData?: string;
  title: string;
  description?: string;
  className?: string;
}

export default function ProjectSitePlan({
  sitePlanData,
  sitePlanImages,
  description,
  title,
  className,
}: ProjectSitePlanProps) {
  const [openGallery, setOpenGallery] = React.useState(false);
  const { t } = useTranslation();
  return (
    <>
      <div
        className={cn(
          "relative flex flex-col gap-6 rounded-xl px-0 py-6 lg:gap-5 lg:rounded-lg lg:px-6 lg:py-4.5",
          className
        )}
      >
        <div className="flex justify-between gap-3">
          <div className="flex flex-col gap-2 lg:gap-1">
            <Typo
              tag={ETypoTag.H3}
              variant={ETypoVariant.HEADER_PROJECT_24}
              color={ETypoColor.PROJECT_HEADING}
              className="font-bold"
            >
              {title}
            </Typo>
            {description && (
              <Typo variant={ETypoVariant.SUB_TITLE_16} tag={ETypoTag.P}>
                {description}
              </Typo>
            )}
          </div>

          {sitePlanImages && (
            <div>
              <Button
                className="min-w-[116px] lg:min-w-[92px] lg:px-3 lg:py-2"
                variant="outline"
                onClick={() => setOpenGallery(true)}
                disabled={sitePlanImages?.urls?.length === 0}
              >
                {t("view")}
              </Button>
            </div>
          )}
        </div>

        {!isEmpty(sitePlanData) && (
          <CleanedContent
            htmlContent={sitePlanData || ""}
            className="scroll h-full max-h-[480px] w-full overflow-auto text-body-title-16 text-color"
          />
        )}
      </div>

      <ModalMediaGallery
        isOpen={openGallery}
        closeModal={() => {
          setOpenGallery(false);
        }}
        medias={[sitePlanImages]}
      />
    </>
  );
}
